import React from 'react';
import { SettingsSelectCustom } from '../form/settings.Widget';

export const BoardToolboxSelect = ({
  value,
  onChange,
  options,
  placeholder,
  minWidthClass = 'min-w-20',
  menuClassName = 'z-60',
}) => (
  <SettingsSelectCustom
    size='sm'
    className={`${minWidthClass} flex-none`}
    buttonClassName='min-h-6 py-01 px-05 text-xs bg-main border border-contrast border-opacity-20'
    menuClassName={menuClassName}
    options={options}
    value={value}
    onChange={e => onChange?.(e.target.value)}
    placeholder={placeholder}
  />
);
